import { trackStylitics, STYLITICS_COUNTRIES_ENABLED } from '../../stylitics'
import { getClientIdByCountry } from './stylitics-helpers'

export const STYLITICS = 'stylitics'

const isProduction = process.env.TARGET_ENV === 'production'
const ENV = isProduction ? 'production' : 'staging'

const isStyliticsEnabled = country => STYLITICS_COUNTRIES_ENABLED.includes(country)

export function trackStyliticsEvent(eventPayload) {
  const { country, ...payload } = eventPayload
  if (isStyliticsEnabled(country)) {
    trackStylitics(payload)
  }
}

export const STYLITICS_EVENTS = {
  trackPurchase: 'trackPurchase',
}

const styliticsEventHandlers = {}

Object.values(STYLITICS_EVENTS).forEach(event => {
  styliticsEventHandlers[event] = (_, payload) => {
    const clientId = getClientIdByCountry(payload.country)
    if (!clientId) return

    trackStyliticsEvent({
      environment: ENV,
      client: clientId,
      ...payload,
    })
  }
})

export default styliticsEventHandlers
